import React, { useContext } from 'react';
import MessagingRouter from '../../Messaging.router';
import MessagingProvider from '../../providers/Messaging';
import ListingContext from '../../../Portfolio/subrouters/Seller/subrouters/ListingDetailSeller/providers/Listing/Listing.context';
import { useLockScrollOnReroute } from 'hooks/useLockScrollOnReroute';

const MessagingSellerWrapper: React.FC = () => {
  const { listing } = useContext(ListingContext);

  const { _id: listingId, dealRoomId } = listing || {};

  useLockScrollOnReroute();

  return (
    <MessagingProvider messagingPortfolioProps={{ listingId, dealRoomId }}>
      <MessagingRouter />
    </MessagingProvider>
  );
};

export default MessagingSellerWrapper;
